import { IMerchant } from "@interfaces";
import { getDeployEnvironment } from "./getDeployEnvironment";

export const getLiffId = (merchant: IMerchant): string => {
    const env = getDeployEnvironment();
    // const lineLoginApi = merchant?.lineIntegration?.lineLoginApi;
    const lineLoginApi = merchant?.lineIntegration?.lineLoginApi;
    const LINE = "line";

    let result = undefined;
    switch (env) {
        //In case development is no LiffId, use UAT LiffId instead.
        case "development":
            result = lineLoginApi?.liffUrlForDev
                ? lineLoginApi?.liffUrlForDev
                : lineLoginApi?.liffUrl;
            break;
        case "preview":
            result = lineLoginApi?.liffUrl;
            break;
        case "production":
            result = lineLoginApi?.liffUrlForProduction;
            break;
    }

    if (!merchant.signUpSettings?.signUpMethod?.toLowerCase().includes(LINE)) {
        console.warn("Using TEL only");
        return "skipLine";
    }

    if (result === undefined) {
        console.error("line login api not found on admin but found using line integration");
        return "error";
    }

    if (result === "") {
        console.warn("No line integration found");
        return "skipLine";
    }

    return result;
};
